import s from './judges.module.scss'

const judges = [
  {
    avatar: '/assets/axie-game-jam/judge-masamune.png',
    name: 'Masamune',
    title: 'Art Director',
  }, {
    avatar: '/assets/axie-game-jam/judge-leo.png',
    name: 'Leo Nguyen',
    title: 'Game Production Director',
  }, {
    avatar: '/assets/axie-game-jam/judge-louis.png',
    name: 'Louis Trinh',
    title: 'Art Lead',
  }, {
    avatar: '/assets/axie-game-jam/judge-kenji.png',
    name: 'Kenji Phan',
    title: 'Senior Game Designer',
  },
]

export const Judges = () => {
  return (
    <div className={s.container}>
      <h3 className={s.title}>Judges</h3>
      <div className={s.judges}>
        {judges.map((judge, index) => (
          <div className={s.judge} key={index}>
            <div className={s.avatar}>
              <img src={judge.avatar} title={judge.name} />
            </div>
            <div className={s.details}>
              <h4>{judge.name}</h4>
              <small>{judge.title}</small>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
